<template>
  <SkeletonBlock
    :is-active="isSkeletonActive"
    :width="width"
    :height="48"
  >
    <slot />
  </SkeletonBlock>
</template>

<script setup lang="ts">
  import { SkeletonBlock } from '@experience/core-skeleton-lib';
  import { useScreenSize } from '@experience/shared';
  import { useListingSkeleton } from '@/shared/composables/useDelayedListingSkeleton.ts';

  const { isMobile } = useScreenSize();

  const width = computed(() => {
    if (isMobile.value) {
      return 'calc(50% - 4px)';
    }

    return 88;
  });

  const { isSkeletonActive } = useListingSkeleton();
</script>

<style lang="scss"></style>
